const faqItems = [
  {
    q: '91电影视频需要注册才能观看吗？',
    a: '不需要。91电影视频所有内容均免费开放，无需注册、无需登录，打开网站即可直接点播观看，真正做到即点即播，方便快捷。',
  },
  {
    q: '视频播放卡顿怎么办？',
    a: '平台采用先进的CDN加速和自适应码率技术，会根据你的网络状况自动调整画质。如果遇到卡顿，建议检查网络连接或手动切换至较低清晰度，通常即可流畅播放。',
  },
  {
    q: '91电影视频支持哪些设备观看？',
    a: '91电影视频全面支持PC电脑、平板和手机浏览器访问，兼容Windows、macOS、iOS和Android等主流操作系统，无需安装任何插件或APP即可享受高清观影体验。',
  },
  {
    q: '网站上的影视资源更新频率如何？',
    a: '我们的编辑团队每日实时追踪最新影视动态，热门剧集通常在播出后数小时内即可上线，院线电影也会在窗口期后尽快更新，确保你能第一时间看到想看的作品。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">常见问题</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">常见问题 · 快速解答</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">关于91电影视频的常见疑问，帮你快速了解平台</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqItems.map((item, i) => (
            <div key={i} className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6">
              <h3 className="font-semibold text-sm md:text-base text-foreground-900 mb-2 flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                  <i className="ri-question-line text-sm"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}